<div
    class="cagov-content-panel panel-fade"
    [ngClass]="{ 'no-shadow': noShadow }"
    [@panelState]="isVisible"
    [style.marginBottom.px]="marginBottom"
>
    <ng-content></ng-content>
</div>
